module.exports = __webpack_public_path__ + "img/city_002.9be46ceb.png";